import { useState } from "react";
import { instance } from "../../../../utils/utils";

const DeleteUserRol = ({ onClose, rolesSelected }) => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const deleteUserRol = async () => {
    setLoader(true);
    try {
      await Promise.all(
        rolesSelected.map((role) => instance.delete(`users/roles/${role}`))
      );
      onClose();
    } catch (err) {
      console.error(err);
      let errorMessage = "Ocurrió un error al eliminar el usuario";
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (err.response.status === 400) {
          // Handle validation errors
          const errors = err.response.data;
          errorMessage = Object.values(errors).flat().join(" ");
        } else if (err.response.status === 401) {
          errorMessage = "No tienes permiso para realizar esta acción";
        } else if (err.response.status >= 500) {
          errorMessage = "Error en el servidor. Por favor, intente más tarde";
        }
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage =
          "No se pudo conectar al servidor. Verifica tu conexión a internet";
      }

      setError(errorMessage);
      setTimeout(() => {
        setError(null);
      }, 3000);
    } finally {
      setLoader(false);
    }
  };
  return (
    <div>
      <div className="mb-4">
        {loader ? (
          <span style={{ textAlign: "center" }}>Eliminando...</span>
        ) : (
          <span style={{ textAlign: "center" }}>
            {rolesSelected.length > 1
              ? "¿Está seguro que desea eliminar los usuarios seleccionados?"
              : "¿Está seguro que desea eliminar el usuario seleccionado?"}
          </span>
        )}
      </div>
      {error && (
        <div
          className="alert alert-danger mt-2 py-1"
          style={{ fontSize: "0.8rem" }}
        >
          {error}
        </div>
      )}

      <div className="d-flex mt-3 justify-content-center align-items-center gap-xl-3 gap-md-2">
        <button
          style={{
            fontSize: "calc(.4rem + .32vw)",
            background: "#3177BE",
          }}
          className="d-flex add_location px-4 py-1"
          onClick={onClose}
        >
          Cancelar
        </button>
        <button
          style={{
            fontSize: "calc(.4rem + .32vw)",
          }}
          className="d-flex add_location px-4 py-1"
          onClick={deleteUserRol}
        >
          Confirmar
        </button>
      </div>
    </div>
  );
};
export default DeleteUserRol;
